module.exports = __webpack_public_path__ + "img/prize-05.47b1d9fd.png";